const services = [
  {
    icon: 'ri-map-2-line',
    category: 'Surveying & Mapping',
    title: 'Geo-information Services',
    description:
      'Comprehensive geospatial solutions including cadastral surveys, topographic mapping, aerial photogrammetry, and remote sensing across East Africa.',
    items: [
      'Cadastral & Boundary Surveys',
      'Topographic & Engineering Surveys',
      'Aerial Photogrammetry & Remote Sensing',
      'Control Survey Networks',
      'GIS Data Modelling & Analysis',
    ],
    image: 'https://storage.readdy-site.link/project_files/fe05d92d-53b5-4c90-ab41-873201f19767/773a7af1-dbd9-4999-8e52-79edd1f6da2c_download-6.jpg?v=bbec6a216c675f2b8700fda61d4623cd',
  },
  {
    icon: 'ri-server-line',
    category: 'Information Technology',
    title: 'IT Services',
    description:
      'End-to-end technology solutions from cloud infrastructure and mobile apps to enterprise resource planning and big data analytics.',
    items: [
      'Cloud Services (AWS, Google Cloud)',
      'Mobile App Development',
      'Enterprise Resource Planning (ERP)',
      'Big Data & Analytics',
      'Software Development & IT Consultancy',
    ],
    image: 'https://storage.readdy-site.link/project_files/fe05d92d-53b5-4c90-ab41-873201f19767/2ba4b606-67cd-46f5-8e7e-0e31f0210cf1_Ai-learning-and-artificial-intelligence-concept_-_-Premium-Photo.jpg?v=b2e5380cccf49d3aa6d8cdba1aca90e8',
  },
  {
    icon: 'ri-bar-chart-2-line',
    category: 'Research & Analytics',
    title: 'Research Services',
    description:
      'Rigorous data collection, analysis, and impact evaluation using industry-leading tools for health, agriculture, climate, and socio-economic research.',
    items: [
      'Socio-Economic & Financial Surveys',
      'Environmental Impact Assessment (EIA)',
      'CAPI Tools (ODK, KoBoToolbox)',
      'R, SPSS, STATA, EViews Analysis',
      'Training & Capacity Building',
    ],
    image: 'https://storage.readdy-site.link/project_files/fe05d92d-53b5-4c90-ab41-873201f19767/5c1e058c-bfc1-4090-9870-7bd29ecbdb7b_Best-Libraries-and-Platforms-for-Data-Visualization.jpg?v=c5f779cdc5e10343082dcbd64722e8cb',
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="mb-16">
          <span className="text-teal-600 text-sm font-semibold tracking-widest uppercase">What We Do</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-4">
            Our Core <span className="text-teal-600">Expertise</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl">
            Three integrated service pillars that help organizations across East Africa harness the power of geospatial data, technology, and research.
          </p>
        </div>

        {/* Services Grid — equal cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div key={service.category} className="rounded-2xl overflow-hidden relative group cursor-pointer flex flex-col">
              {/* Image */}
              <div className="relative h-52 flex-shrink-0 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-teal-900/30 to-teal-950/70"></div>
                <div className="absolute top-4 left-4">
                  <span className="bg-teal-500/20 border border-teal-400/40 text-teal-200 text-xs font-semibold px-3 py-1 rounded-full">
                    {service.category}
                  </span>
                </div>
              </div>
              {/* Content */}
              <div className="bg-teal-950 p-6 flex flex-col flex-1">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-teal-800 mb-3">
                  <i className={`${service.icon} text-teal-300 text-xl`}></i>
                </div>
                <h3 className="text-white text-lg font-bold mb-2">{service.title}</h3>
                <p className="text-teal-200/70 text-lg mb-4 leading-relaxed">{service.description}</p>
                <ul className="space-y-1.5 mt-auto">
                  {service.items.map((item) => (
                    <li key={item} className="flex items-center gap-2 text-teal-300 text-sm">
                      <i className="ri-check-line text-xs"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
